$(document).ready(function() {
    var checkCookieBanner = setInterval(function() {
        if ($('#shopify-pc__prefs__preferences-input').length) {
            $('#shopify-pc__prefs__preferences-input').trigger('click');
            $('#shopify-pc__prefs__marketing-input').trigger('click');
            $('#shopify-pc__prefs__analytics-input').trigger('click');
            $('#shopify-pc__prefs__analytics label').css({
                'background': 'white',
                'color': 'black'
            });
            clearInterval(checkCookieBanner); 
        }
    }, 100); 
});